module.exports = __webpack_public_path__ + "img/logo-bg-white.54e194bf.svg";